// @ts-nocheck
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useCardStyles from "@store/Library/Widgets/Card/useCardStyles";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React from "react";
import styled, { css } from "styled-components";

export type CardBodyStyles = InjectableCss;
const CardBody = styled.div<InjectableCss>`
    ${injectCss}
`;
interface CardBodyProps {
    extendedStyles?: CardBodyStyles;
    overrideStyles?: CardBodyStyles;
    className?: string;
}
const defaultCardBodyStyles: CardBodyStyles = {
    css: css`
        flex: 1 1 0;
    `,
};
const CardBodyComponent: React.FC<CardBodyProps> = ({ children, extendedStyles, overrideStyles, className }) => {
    const cardBodyStyles = { ...defaultCardBodyStyles, ...useCardStyles().body };
    const styles = useExpandProps(cardBodyStyles, extendedStyles, overrideStyles);
    return (
        <CardBody {...styles} className={className}>
            {children}
        </CardBody>
    );
};

export default CardBodyComponent;
